import loadable from "@loadable/component";
import AppLoader from "app/App/components/AppLoader";
import { FC } from "react";
import { useSelector } from "react-redux";
import AppError from "./AppError";

const App = loadable(() => import("app/App"));

const AppInit: FC = () => {
    const { loaded, errorMessage } = useSelector((state: any) => state.app);

    if (!loaded) {
        return <AppLoader />;
    } else if (errorMessage) {
        return <AppError />;
    }

    return <App />;
};

export default AppInit;
